import { useContext } from 'react'

import { EmailChangeContext } from './email-change-context'

export function useEmailChange() {
  const ctx = useContext(EmailChangeContext)
  if (!ctx)
    throw new Error('useEmailChange must be used within EmailChangeProvider')
  return ctx
}
